import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { HeatPumpIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";

export const IncreaseExpectedElectricHeatPumpForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEAT_PUMP_V2>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HeatPumpIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Wärmepumpe
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricHeatPumpV2.value.yes}
                        {...getFieldProps("increaseExpectedHeatPumpV2.value.yes")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricHeatPumpV2.value.yes = checked;
                                values.increaseExpectedElectricHeatPumpV2.value.no = !checked;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricHeatPumpV2.value.yes}
                detail={
                    <p className={classes.p}>
                        Nachdem Sie diesen Antrag für Ihre Leistungserhöhung abgesendet haben,
                        erfassen Sie bitte einen weiteren Antrag über den Prozess "Verbrauchsgeräte,
                        z.B. Ladeeinrichtung, Wärmepumpe, Gerät zur Raumkühlung".
                    </p>
                }
            />
        </Fragment>
    );
};
